import { createFileRoute } from "@tanstack/react-router";
import Projects from "@/pages/Projects";

export const Route = createFileRoute("/projects")({
  head: () => ({
    meta: [
      {
        title: "Our Screeding Projects in Exeter & Devon | Exeter Flow Screeds",
      },
      {
        name: "description",
        content:
          "Browse our gallery of liquid screed and floor prep projects across Exeter, Devon, Somerset and the South West. See real results from new-builds, UFH, and commercial pours.",
      },
      {
        property: "og:title",
        content:
          "Our Screeding Projects in Exeter & Devon | Exeter Flow Screeds",
      },
      {
        property: "og:description",
        content:
          "Browse our gallery of liquid screed and floor prep projects across Exeter, Devon, Somerset and the South West. See real results from new-builds, UFH, and commercial pours.",
      },
      {
        property: "og:url",
        content: "https://exeterflowscreed.co.uk/projects",
      },
      {
        property: "og:image",
        content:
          "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6a7469d1e76789340f9e87b3.webp",
      },
      {
        name: "twitter:title",
        content:
          "Our Screeding Projects in Exeter & Devon | Exeter Flow Screeds",
      },
      {
        name: "twitter:description",
        content:
          "Browse our gallery of liquid screed and floor prep projects across Exeter, Devon, Somerset and the South West. See real results from new-builds, UFH, and commercial pours.",
      },
      {
        name: "twitter:image",
        content:
          "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6a7469d1e76789340f9e87b3.webp",
      },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://exeterflowscreed.co.uk/projects",
      },
    ],
  }),
  component: Projects,
});
